import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=e3cb0b80&scoped=true&"
import script from "./Sort.vue?vue&type=script&lang=js&"
export * from "./Sort.vue?vue&type=script&lang=js&"
import style0 from "./Sort.vue?vue&type=style&index=0&id=e3cb0b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cb0b80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VTab,VTabs})
